import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "value", "getLabel", "as"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import i18n from 'i18next';
import getDuration from './getDuration';
import { jsx as _jsx } from "react/jsx-runtime";
function zeroPad(number) {
  if (number < 10) {
    return String(number).padStart(2, '0');
  } else return number;
}
function getDefaultLabel(minutes, hours) {
  if (hours) {
    return "".concat(i18n.t('hour', {
      count: hours
    }), ", ").concat(i18n.t('minute', {
      count: minutes
    }));
  } else return i18n.t('minute', {
    count: minutes
  });
}
function getDefaultChildren(duration) {
  var hours = duration.hours,
    minutes = duration.minutes,
    seconds = duration.seconds;
  var durationFragments = hours ? [hours, zeroPad(minutes), zeroPad(seconds)] : [minutes, zeroPad(seconds)];
  return durationFragments.join(':');
}
function Duration(props) {
  var _props$children = props.children,
    children = _props$children === void 0 ? getDefaultChildren : _props$children,
    _props$value = props.value,
    value = _props$value === void 0 ? 0 : _props$value,
    _props$getLabel = props.getLabel,
    getLabel = _props$getLabel === void 0 ? getDefaultLabel : _props$getLabel,
    _props$as = props.as,
    Component = _props$as === void 0 ? 'span' : _props$as,
    otherProps = _objectWithoutProperties(props, _excluded);
  var duration = getDuration(value);
  return /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, otherProps), {}, {
    "aria-label": getLabel(duration.minutes, duration.hours),
    children: children(duration)
  }));
}
export { getDuration };
export default Duration;